import { render, staticRenderFns } from "./TariffversionDataGrid.vue?vue&type=template&id=d7bb1a8e&scoped=true&"
import script from "./TariffversionDataGrid.vue?vue&type=script&lang=js&"
export * from "./TariffversionDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./TariffversionDataGrid.vue?vue&type=style&index=0&id=d7bb1a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bb1a8e",
  null
  
)

export default component.exports